import getLocaleFromUrl from './get-locale-from-url';
import getURLWithoutLocale from './get-url-without-locale';

export default {
  getLocaleFromUrl,
  getURLWithoutLocale,
};
